module.exports = __webpack_public_path__ + "static/media/heat_1.4d79cff1.png";